// extracted by mini-css-extract-plugin
module.exports = {"recordImageWrapper":"ImageSection_recordImageWrapper__uY3da","recordImage":"ImageSection_recordImage__tw8v1"};